import React from "react";
import { getUrl } from "../../helpers/Pipes";

export const Footer = ({ customClasses }) => {
  return (
    <footer className={["footer", customClasses].join(" ")}>
      <div className="container">
        <p className="copy">
          © Compass Banca S.p.A., socio unico direzione e coordinamento
          Mediobanca S.p.A., Tutti i diritti riservati -
          <span className="nowrap">
            Per i dati Societari{" "}
            <a target={"_blank"} href={getUrl("datiSocietari")}>
              clicca qui
            </a>
          </span>
        </p>
      </div>
    </footer>
  );
};
